import './styles.scoped.css'
import {Typography, Button, IconButton, Tabs, Tab} from '@mui/material'
import {Menu as MenuIcon, DateRange, Download} from '@mui/icons-material'
import {useState, useEffect} from 'react'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {useNavigate} from 'react-router-dom'
import {useMobile} from '../../hooks'
import {ScheduleVisits} from './components'
import {clientApi} from '../../services'
import {parseError} from '../../utils/helpers'
import dayjs from 'dayjs'
import {NotificationIcon} from '../../components'

export default () => {
    const {setMobileSidebar, setMessageBox, branchId} = useGlobalStates()
    const [tab, setTab] = useState(0)
    const navigate = useNavigate()
    const {mobile} = useMobile()
    const [clients, setClients] = useState([])
    const [services, setServices] = useState([])
    const [startDate, setStartDate] = useState(dayjs())
    const [endDate, setEndDate] = useState(dayjs())

    useEffect(() => {
        if (mobile) {
            setMobileSidebar(false)
        }
    }, [])

    useEffect(() => {
        if (branchId) {
            clientApi
                .getBranchClients(branchId, {limit: 100})
                .then(
                    ({
                        data: {
                            data: {data},
                        },
                    }) => {
                        setClients(data?.map(item => ({...item, display_name: item?.first_name + ' ' + item?.last_name})))
                    },
                )
                .catch(error => {
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })

            clientApi
                .getBranchServices({branch_id: branchId})
                .then(({data: {data}}) => {
                    setServices(data?.map(item => ({...item, id: item?.service_id, display_name: item?.service_name})))
                })
                .catch(error => {
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })
        }
    }, [branchId])

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <div className="title">
                            <IconButton onClick={() => setMobileSidebar(true)}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="text.primary">
                                Schedule Management
                            </Typography>
                        </div>
                        <NotificationIcon />
                    </div>
                    <br />
                    <br />
                    <br />
                    <div className="actions">
                        <Button variant="outlined" startIcon={<Download />} style={{flex: 1}}>
                            Export Schedules
                        </Button>
                        <Button variant="contained" startIcon={<DateRange />} onClick={() => navigate('/scheduling/schedule-form')} style={{flex: 1}}>
                            Create Schedule
                        </Button>
                    </div>
                    <br />
                </>
            ) : (
                <>
                    <div className="header">
                        <Typography variant="h5" color="text.primary">
                            Schedule Management
                        </Typography>
                        <div className="actions">
                            <Button variant="outlined" startIcon={<Download />} style={{minWidth: 160}}>
                                Export Schedules
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<DateRange />}
                                onClick={() => navigate('/scheduling/schedule-form')}
                                style={{minWidth: 160}}>
                                Create Schedule
                            </Button>
                        </div>
                    </div>
                    <br />
                    <br />
                </>
            )}
            <Tabs
                value={tab}
                onChange={(e, newValue) => setTab(newValue)}
                allowScrollButtonsMobile
                variant={'scrollable'}
                style={{width: mobile ? 420 : '100%'}}>
                <Tab label="All Statuses" />
                <Tab label="Scheduled" />
                <Tab label="In Progress" />
                <Tab label="Ended" />
                <Tab label="Finished" />
                <Tab label="Completed" />
                <Tab label="Cancelled" />
            </Tabs>
            <br />
            {tab === 0 && (
                <ScheduleVisits
                    status="all_status"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
            {tab === 1 && (
                <ScheduleVisits
                    status="scheduled"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
            {tab === 2 && (
                <ScheduleVisits
                    status="in_progress"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
            {tab === 3 && (
                <ScheduleVisits
                    status="ended"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
            {tab === 4 && (
                <ScheduleVisits
                    status="finished"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
            {tab === 5 && (
                <ScheduleVisits
                    status="completed"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
            {tab === 6 && (
                <ScheduleVisits
                    status="cancelled"
                    clients={clients}
                    services={services}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            )}
        </>
    )
}
